import { mapMutations } from 'vuex';

export default {
    mounted() {
        this.setFormSubmitting(false);
    },
    methods: {
        ...mapMutations(['setFormSubmitting']),
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/marketing.js